import DealerPointHistoryListPanel from "./dealerPointHistoryListPanel.container"

export default DealerPointHistoryListPanel
